import { Badge } from '@/components/ui/atoms/badge'
import { Button } from '@/components/ui/atoms/button'
import { cn } from '@/lib/client'
import { XIcon } from 'lucide-react'

interface SearchProps {
  theme?: string | undefined
  href: string
  handleSearch: (value: { type?: string; value: string }) => void
  selected?: Array<{
    type?: string | undefined
    value?: string | null
  }>
}

export default function SearchTerms({
  theme = 'dark',
  href,
  handleSearch,
  selected,
}: SearchProps) {
  return (
    <div className={theme}>
      <span className="flex gap-2 text-sm flex-wrap">
        {(selected || [])?.length > 0 && (
          <>
            {selected?.map((item) => (
              <Badge
                key={item.value}
                className={cn(
                  'text-sm border rounded-sm shadow-md bg-background border-zinc-300 text-zinc-500 hover:text-zinc-500 hover:bg-background dark:border-zinc-600 dark:text-zinc-300 dark:hover:text-zinc-100 dark:hover:bg-zinc-50/20',
                  'pr-0 py-0',
                )}
              >
                {item.value}
                <div
                  data-value={item.type || 'free'}
                  className={
                    'border-l ml-2 p-1 h-full items-center flex cursor-pointer border-zinc-300 text-zinc-500 dark:text-zinc-300 dark:border-zinc-500 hover:bg-zinc-50/20 dark:hover:text-white dark:hover:bg-zinc-50/20'
                  }
                  onClick={(ev) => {
                    handleSearch({
                      type: ev.currentTarget.dataset.value,
                      value: '0',
                    })
                  }}
                  onKeyDown={() => {}}
                >
                  <XIcon className="h-4 w-4 text-zinc-500 dark:text-zinc-300" />
                </div>
              </Badge>
            ))}
            {(selected || [])?.length > 1 && (
              <div
                className={`
                  ml-1 pl-3
                  border-l border-zinc-500 dark:border-zinc-600
              `}
              >
                <Button
                  variant={'outline'}
                  className={`
                    h-7 rounded-sm text-xs border shadow-md
                    border-zinc-400 text-zinc-500 hover:text-zinc-500 hover:border-zinc-400 hover:bg-background
                    dark:text-white dark:bg-zinc-50/10 dark:hover:bg-white dark:hover:text-white dark:hover:bg-zinc-50/20
                  `}
                  size={'sm'}
                  asChild
                >
                  <a href={href}>Limpar filtros</a>
                </Button>
              </div>
            )}
          </>
        )}
      </span>
    </div>
  )
}
